// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Swal from '../librarianSwal';
// import { useAuth } from '../../Constant/Auth';
// import { useActiveLibraryId, useSectionBase } from '../../Constant/useActiveLibrary';
// import SearchableSelect from '../../shared/SearchableSelect';

// import {
//   getBooksByLibrary,
//   getAvailableCopiesByBookId,
//   getMembersByLibrary,
//   getReservationsByStatus,
//   addIssue,
//   getCopyByScanCode,
//   getMemberByScanCode,
//   getErrorMessage
// } from '../../api/api';
// import '../lib-page-header.css';

// const getTodayDate = () => {
//   return new Date().toISOString().slice(0, 10);
// };

// const getDefaultDueDate = () => {
//   const date = new Date();
//   date.setDate(date.getDate() + 14);
//   return date.toISOString().slice(0, 10);
// };

// const IssueBook = () => {
//   const navigate = useNavigate();
//   const sectionBase = useSectionBase();
//   const { user } = useAuth();

//   const libraryId = useActiveLibraryId();
//   const staffId = user?.id || user?.staff_id;

//   const [loading, setLoading] = useState(false);
//   const [members, setMembers] = useState([]);
//   const [books, setBooks] = useState([]);
//   const [copies, setCopies] = useState([]);
//   const [readyRequests, setReadyRequests] = useState([]);

//   const [memberScanCode, setMemberScanCode] = useState('');
//   const [bookScanCode, setBookScanCode] = useState('');
//   const [scanLoading, setScanLoading] = useState({ member: false, book: false });

//   const [formData, setFormData] = useState({
//     issue_source: 'direct',
//     reservation_id: '',
//     membership_id: '',
//     member_id: '',
//     student_id: '',
//     book_id: '',
//     book_copy_id: '',
//     issue_date: getTodayDate(),
//     due_date: getDefaultDueDate(),
//     remarks: ''
//   });

//   const fetchInitialData = async () => {
//     try {
//       if (!libraryId) return;

//       setLoading(true);

//       const [memberData, bookData, reservationData] = await Promise.all([
//         getMembersByLibrary(libraryId),
//         getBooksByLibrary(libraryId),
//         getReservationsByStatus(libraryId, 'ready_for_pickup')
//       ]);

//       setMembers(memberData || []);
//       setBooks(bookData || []);
//       setReadyRequests(reservationData || []);
//     } catch (error) {
//       console.error('Issue book initial data error:', error);
//       Swal.fire('Error', getErrorMessage(error), 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchAvailableCopies = async (bookId) => {
//     try {
//       if (!bookId) {
//         setCopies([]);
//         return;
//       }

//       const data = await getAvailableCopiesByBookId(bookId);
//       setCopies(data || []);
//     } catch (error) {
//       console.error('Fetch available copies error:', error);
//       Swal.fire('Error', getErrorMessage(error), 'error');
//     }
//   };

//   useEffect(() => {
//     fetchInitialData();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [libraryId]);

//   const handleChange = async (e) => {
//     const { name, value } = e.target;

//     if (name === 'issue_source') {
//       setFormData({
//         issue_source: value,
//         reservation_id: '',
//         membership_id: '',
//         member_id: '',
//         student_id: '',
//         book_id: '',
//         book_copy_id: '',
//         issue_date: getTodayDate(),
//         due_date: getDefaultDueDate(),
//         remarks: ''
//       });

//       setCopies([]);
//       return;
//     }

//     if (name === 'reservation_id') {
//       const selectedRequest = readyRequests.find(
//         (item) => String(item.id) === String(value)
//       );

//       if (!selectedRequest) {
//         setFormData((prev) => ({
//           ...prev,
//           reservation_id: value
//         }));
//         return;
//       }

//       const assignedCopyId =
//         selectedRequest.reserved_copy_id ||
//         selectedRequest.book_copy_id ||
//         selectedRequest.copy_id ||
//         '';

//       setFormData((prev) => ({
//         ...prev,
//         reservation_id: selectedRequest.id,
//         membership_id: selectedRequest.membership_id || '',
//         member_id: selectedRequest.member_id || '',
//         student_id: selectedRequest.student_id || '',
//         book_id: selectedRequest.book_id || '',
//         book_copy_id: assignedCopyId
//       }));

//       if (selectedRequest.book_id) {
//         await fetchAvailableCopies(selectedRequest.book_id);
//       }

//       return;
//     }

//     if (name === 'member_id') {
//       const selectedMember = members.find(
//         (item) => String(item.id) === String(value)
//       );

//       setFormData((prev) => ({
//         ...prev,
//         member_id: value,
//         membership_id:
//           selectedMember?.membership_id ||
//           selectedMember?.active_membership_id ||
//           '',
//         student_id: selectedMember?.student_id || ''
//       }));

//       return;
//     }

//     if (name === 'book_id') {
//       setFormData((prev) => ({
//         ...prev,
//         book_id: value,
//         book_copy_id: ''
//       }));

//       await fetchAvailableCopies(value);
//       return;
//     }

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleMemberScan = async (code) => {
//     if (!code.trim() || !libraryId) return;
//     setScanLoading((prev) => ({ ...prev, member: true }));
//     try {
//       const member = await getMemberByScanCode(libraryId, code.trim());
//       if (!member?.id) {
//         Swal.fire('Not Found', 'No member found for this scan code', 'warning');
//         return;
//       }
//       setFormData((prev) => ({
//         ...prev,
//         member_id: String(member.id),
//         membership_id: member.membership_id || member.active_membership_id || '',
//         student_id: member.student_id || ''
//       }));
//       if (!members.find((m) => String(m.id) === String(member.id))) {
//         setMembers((prev) => [member, ...prev]);
//       }
//     } catch (error) {
//       Swal.fire('Error', getErrorMessage(error), 'error');
//     } finally {
//       setScanLoading((prev) => ({ ...prev, member: false }));
//       setMemberScanCode('');
//     }
//   };

//   const handleBookCopyScan = async (code) => {
//     if (!code.trim() || !libraryId) return;
//     setScanLoading((prev) => ({ ...prev, book: true }));
//     try {
//       const copy = await getCopyByScanCode(libraryId, code.trim());
//       if (!copy?.id) {
//         Swal.fire('Not Found', 'No book copy found for this scan code', 'warning');
//         return;
//       }
//       const bookId = String(copy.book_id || copy.Book_ID || '');
//       setFormData((prev) => ({
//         ...prev,
//         book_id: bookId,
//         book_copy_id: String(copy.id)
//       }));
//       if (bookId) await fetchAvailableCopies(bookId);
//     } catch (error) {
//       Swal.fire('Error', getErrorMessage(error), 'error');
//     } finally {
//       setScanLoading((prev) => ({ ...prev, book: false }));
//       setBookScanCode('');
//     }
//   };

//   const validateForm = () => {
//     if (!libraryId) {
//       Swal.fire('Error', 'Library ID not found', 'error');
//       return false;
//     }

//     if (!formData.member_id) {
//       Swal.fire('Error', 'Please select member', 'error');
//       return false;
//     }

//     if (!formData.book_id) {
//       Swal.fire('Error', 'Please select book', 'error');
//       return false;
//     }

//     if (!formData.book_copy_id) {
//       Swal.fire('Error', 'Please select book copy', 'error');
//       return false;
//     }

//     if (!formData.issue_date) {
//       Swal.fire('Error', 'Issue date is required', 'error');
//       return false;
//     }

//     if (!formData.due_date) {
//       Swal.fire('Error', 'Due date is required', 'error');
//       return false;
//     }

//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) return;

//     const payload = {
//       library_id: libraryId,
//       membership_id: formData.membership_id || null,
//       member_id: formData.member_id,
//       student_id: formData.student_id || null,
//       reservation_id:
//         formData.issue_source === 'parent_request'
//           ? formData.reservation_id || null
//           : null,
//       book_copy_id: formData.book_copy_id,
//       issued_by_staff_id: staffId,
//       returned_to_staff_id: null,
//       issue_date: formData.issue_date,
//       due_date: formData.due_date,
//       return_date: null,
//       renew_count: 0,
//       issue_status: 'issued',
//       book_return_condition: null,
//       issue_source: formData.issue_source,
//       remarks: formData.remarks || null
//     };

//     try {
//       setLoading(true);

//       await addIssue(payload);

//       await Swal.fire({
//         icon: 'success',
//         title: 'Success',
//         text: 'Book issued successfully'
//       });

//       navigate(`${sectionBase}/issues`);
//     } catch (error) {
//       console.error('Issue book error:', error);
//       Swal.fire('Error', getErrorMessage(error), 'error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const selectedBook = books.find(
//     (book) => String(book.id) === String(formData.book_id)
//   );

//   const selectedMember = members.find(
//     (member) => String(member.id) === String(formData.member_id)
//   );

//   return (
//     <div className="container-fluid mt-3">
//       <div className="lib-page-header">
//         <div className="lib-page-header__left">
//           <div className="lib-page-header__icon">
//             <i className="fas fa-book-reader" />
//           </div>
//           <div>
//             <h3 className="lib-page-header__title">Issue Book</h3>
//             <div className="lib-page-header__subtitle">Issue book directly or against approved parent request</div>
//           </div>
//         </div>
//         <div className="lib-page-header__actions">
//           <button
//             type="button"
//             className="btn btn-secondary"
//             onClick={() => navigate(`${sectionBase}/issues`)}
//           >
//             Back
//           </button>
//         </div>
//       </div>

//       <form onSubmit={handleSubmit}>
//         <div className="card shadow-sm mb-3">
//           <div className="card-header fw-bold"><i className="fas fa-clipboard-list me-2" />Issue Source</div>

//           <div className="card-body">
//             <div className="row">
//               <div className="col-md-4 mb-3">
//                 <label className="form-label">Issue Source *</label>
//                 <SearchableSelect
//                   name="issue_source"
//                   value={formData.issue_source}
//                   onChange={handleChange}
//                   options={[
//                     { value: 'direct', label: 'Direct Issue' },
//                     { value: 'parent_request', label: 'Parent Request' },
//                     { value: 'staff_issue', label: 'Staff Issue' }
//                   ]}
//                   clearable={false}
//                 />
//               </div>

//               {formData.issue_source === 'parent_request' && (
//                 <div className="col-md-8 mb-3">
//                   <label className="form-label">Approved Parent Request *</label>
//                   <SearchableSelect
//                     name="reservation_id"
//                     value={formData.reservation_id}
//                     onChange={handleChange}
//                     options={readyRequests.map((request) => ({
//                       value: request.id,
//                       label: `${
//                         request.member_name ||
//                         request.parent_name ||
//                         request.full_name ||
//                         'Member'
//                       } - ${request.title || request.book_title || 'Book'} - Copy: ${
//                         request.accession_no ||
//                         request.copy_accession_no ||
//                         request.barcode ||
//                         '-'
//                       }`
//                     }))}
//                     placeholder="Select Ready For Pickup Request"
//                   />
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>

//         <div className="card shadow-sm mb-3">
//           <div className="card-header fw-bold"><i className="fas fa-user me-2" />Member Details</div>

//           <div className="card-body">
//             <div className="row">
//               <div className="col-md-12 mb-3">
//                 <label className="form-label">
//                   <i className="fas fa-barcode me-1" />Scan Member Card
//                 </label>
//                 <div className="input-group">
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Scan or type member barcode / QR code, then press Enter"
//                     value={memberScanCode}
//                     onChange={(e) => setMemberScanCode(e.target.value)}
//                     onKeyDown={(e) => {
//                       if (e.key === 'Enter') { e.preventDefault(); handleMemberScan(memberScanCode); }
//                     }}
//                     disabled={scanLoading.member || formData.issue_source === 'parent_request'}
//                   />
//                   <button
//                     type="button"
//                     className="btn btn-outline-secondary"
//                     onClick={() => handleMemberScan(memberScanCode)}
//                     disabled={scanLoading.member || !memberScanCode.trim() || formData.issue_source === 'parent_request'}
//                   >
//                     {scanLoading.member
//                       ? <span className="spinner-border spinner-border-sm" />
//                       : <i className="fas fa-search" />}
//                   </button>
//                 </div>
//                 <div className="form-text">Or select from the dropdown below</div>
//               </div>

//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Member *</label>
//                 <SearchableSelect
//                   name="member_id"
//                   value={formData.member_id}
//                   onChange={handleChange}
//                   options={members.map((member) => ({
//                     value: member.id,
//                     label: `${
//                       member.full_name ||
//                       member.member_name ||
//                       member.parent_name ||
//                       'Member'
//                     } ${member.mobile ? `- ${member.mobile}` : ''}`
//                   }))}
//                   placeholder="Select Member"
//                   disabled={formData.issue_source === 'parent_request'}
//                   required
//                 />
//               </div>

//               <div className="col-md-3 mb-3">
//                 <label className="form-label">Membership ID</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={formData.membership_id}
//                   disabled
//                 />
//               </div>

//               <div className="col-md-3 mb-3">
//                 <label className="form-label">Student ID</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   value={formData.student_id}
//                   disabled
//                 />
//               </div>

//               <div className="col-md-12 mb-2">
//                 <small className="text-muted">
//                   Selected Member:{' '}
//                   <strong>
//                     {selectedMember
//                       ? selectedMember.full_name ||
//                         selectedMember.member_name ||
//                         selectedMember.parent_name
//                       : '-'}
//                   </strong>
//                 </small>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="card shadow-sm mb-3">
//           <div className="card-header fw-bold"><i className="fas fa-book me-2" />Book Details</div>

//           <div className="card-body">
//             <div className="row">
//               <div className="col-md-12 mb-3">
//                 <label className="form-label">
//                   <i className="fas fa-barcode me-1" />Scan Book Copy
//                 </label>
//                 <div className="input-group">
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Scan book barcode or accession number, then press Enter"
//                     value={bookScanCode}
//                     onChange={(e) => setBookScanCode(e.target.value)}
//                     onKeyDown={(e) => {
//                       if (e.key === 'Enter') { e.preventDefault(); handleBookCopyScan(bookScanCode); }
//                     }}
//                     disabled={scanLoading.book || formData.issue_source === 'parent_request'}
//                   />
//                   <button
//                     type="button"
//                     className="btn btn-outline-secondary"
//                     onClick={() => handleBookCopyScan(bookScanCode)}
//                     disabled={scanLoading.book || !bookScanCode.trim() || formData.issue_source === 'parent_request'}
//                   >
//                     {scanLoading.book
//                       ? <span className="spinner-border spinner-border-sm" />
//                       : <i className="fas fa-search" />}
//                   </button>
//                 </div>
//                 <div className="form-text">Or select from the dropdowns below</div>
//               </div>

//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Book *</label>
//                 <SearchableSelect
//                   name="book_id"
//                   value={formData.book_id}
//                   onChange={handleChange}
//                   options={books.map((book) => ({
//                     value: book.id,
//                     label: `${book.title} ${book.author_name ? `- ${book.author_name}` : ''}`
//                   }))}
//                   placeholder="Select Book"
//                   disabled={formData.issue_source === 'parent_request'}
//                   required
//                 />
//               </div>

//               <div className="col-md-6 mb-3">
//                 <label className="form-label">Book Copy *</label>
//                 <SearchableSelect
//                   name="book_copy_id"
//                   value={formData.book_copy_id}
//                   onChange={handleChange}
//                   options={[
//                     ...copies.map((copy) => ({
//                       value: copy.id,
//                       label: `${copy.accession_no || '-'} | ${copy.barcode || '-'} | Copy ${
//                         copy.copy_number || '-'
//                       }`
//                     })),
//                     ...(formData.issue_source === 'parent_request' &&
//                     formData.book_copy_id &&
//                     !copies.some(
//                       (copy) => String(copy.id) === String(formData.book_copy_id)
//                     )
//                       ? [
//                           {
//                             value: formData.book_copy_id,
//                             label: `Assigned Copy #${formData.book_copy_id}`
//                           }
//                         ]
//                       : [])
//                   ]}
//                   placeholder="Select Copy"
//                   required
//                 />
//               </div>

//               <div className="col-md-12 mb-2">
//                 <small className="text-muted">
//                   Selected Book:{' '}
//                   <strong>{selectedBook ? selectedBook.title : '-'}</strong>
//                 </small>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="card shadow-sm mb-3">
//           <div className="card-header fw-bold"><i className="fas fa-calendar-alt me-2" />Issue Date Details</div>

//           <div className="card-body">
//             <div className="row">
//               <div className="col-md-4 mb-3">
//                 <label className="form-label">Issue Date *</label>
//                 <input
//                   type="date"
//                   name="issue_date"
//                   className="form-control"
//                   value={formData.issue_date}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               <div className="col-md-4 mb-3">
//                 <label className="form-label">Due Date *</label>
//                 <input
//                   type="date"
//                   name="due_date"
//                   className="form-control"
//                   value={formData.due_date}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               <div className="col-md-12 mb-3">
//                 <label className="form-label">Remarks</label>
//                 <textarea
//                   name="remarks"
//                   rows="3"
//                   className="form-control"
//                   value={formData.remarks}
//                   onChange={handleChange}
//                   placeholder="Enter remarks if any"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="text-end mb-4">
//           <button
//             type="button"
//             className="btn btn-light me-2"
//             onClick={() => navigate(`${sectionBase}/issues`)}
//           >
//             Cancel
//           </button>

//           <button
//             type="submit"
//             className="btn btn-primary"
//             disabled={loading}
//           >
//             {loading ? 'Issuing...' : 'Issue Book'}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default IssueBook;







import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from '../librarianSwal';
import { useAuth } from '../../Constant/Auth';
import { useActiveLibraryId, useSectionBase } from '../../Constant/useActiveLibrary';
import SharedSearchableSelect from '../../shared/SearchableSelect';

import {
  getBooksByLibrary,
  getAvailableCopiesByBookId,
  getMembersByLibrary,
  getReservationsByStatus,
  addIssue,
  getMemberFines,
  getIssuesByLibrary,
  getCopyByScanCode,
  getMemberByScanCode,
  getIssueById,
  getIssueRenewalsByIssueId,
  getFinesByLibrary,
  getErrorMessage
} from '../../api/api';

import { readPrefetched } from '../../api/prefetchCache';
import './IssueBook.css';
import '../lib-page-header.css';
import '../lib-typography.css';
import { exportToCSV } from '../exportUtils';
import Pagination from '../components/Pagination';

const ISSUES_RESOURCE = 'issues';
const ISSUE_PAGE_SIZE = 10;
const today = () => new Date().toISOString().slice(0, 10);

const defaultDue = () => {
  const d = new Date();
  d.setDate(d.getDate() + 14);
  return d.toISOString().slice(0, 10);
};

const MAX_ISSUE_LIMIT = 5;
const MAX_FINE_LIMIT = 500;

const safeArray = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.rows)) return data.rows;
  return [];
};

const getFullName = (item) => {
  return (
    item?.full_name ||
    item?.member_name ||
    item?.parent_name ||
    `${item?.first_name || ''} ${item?.last_name || ''}`.trim() ||
    item?.name ||
    'Member'
  );
};

const getMobile = (item) => {
  return item?.mobile || item?.phone || item?.mobile_no || '';
};

const getCopyStatus = (copy) => {
  return String(
    copy?.status ||
      copy?.availability_status ||
      copy?.copy_status ||
      ''
  )
    .trim()
    .toLowerCase();
};

const isCopyAvailable = (copy) => {
  const status = getCopyStatus(copy);
  const isDiscarded = Number(copy?.is_discarded || 0);

  return status === 'available' && isDiscarded === 0;
};

const normalizeCopy = (copy) => {
  return {
    ...copy,
    id:
      copy?.id ||
      copy?.copy_id ||
      copy?.book_copy_id ||
      copy?.Book_Copy_ID ||
      '',
    availability_status:
      copy?.availability_status ||
      copy?.status ||
      copy?.copy_status ||
      '',
    status:
      copy?.status ||
      copy?.availability_status ||
      copy?.copy_status ||
      '',
    condition:
      copy?.condition ||
      copy?.condition_status ||
      copy?.book_return_condition ||
      'Good'
  };
};

const normalizeMember = (member) => {
  const fullName = getFullName(member);
  const mobile = getMobile(member);

  return {
    ...member,
    full_name: fullName,
    member_name: member?.member_name || fullName,
    mobile,
    phone: member?.phone || mobile,
    photo: member?.photo || member?.profile_image || member?.user_img || '',
    membership_id:
      member?.membership_id ||
      member?.active_membership_id ||
      member?.membershipId ||
      '',
    active_membership_id:
      member?.active_membership_id ||
      member?.membership_id ||
      member?.membershipId ||
      '',
    student_id:
      member?.student_id ||
      member?.linked_student_id ||
      member?.studentId ||
      '',
    membership_type:
      member?.membership_type ||
      member?.member_source ||
      member?.member_type ||
      '',
    membership_status:
      member?.membership_status ||
      member?.active_membership_status ||
      ''
  };
};

const normalizeBook = (book) => {
  return {
    ...book,
    title: book?.title || book?.book_title || book?.name || 'Book'
  };
};

const getFineStatus = (fine) => fine?.fine_status || fine?.status || '';

const getFineAmount = (fine) => {
  return Number(
    fine?.balance_amount ??
      fine?.amount ??
      fine?.fine_amount ??
      0
  );
};

const CompactIssuedPanel = ({
  issues,
  search,
  setSearch,
  onRefresh,
  loading,
  libraryId
}) => {
  const navigate = useNavigate();
  const sectionBase = useSectionBase();
  const tableWrapRef = useRef(null);
  const [detailIssue, setDetailIssue] = useState(null);
  const [page, setPage] = useState(1);

  // Its own scroll region (independent of the page/window scroll) — reset it
  // on mount too so a previous session's scrolled-down list position doesn't
  // carry over when this panel remounts.
  useEffect(() => {
    if (tableWrapRef.current) tableWrapRef.current.scrollTop = 0;
  }, []);
  const [detailLoading, setDetailLoading] = useState(false);

  // Fine + renewal history for the open details modal — neither is on the
  // issue record itself, so they're read separately (view-only, no new
  // issue/return endpoint) once the modal opens.
  const [detailFine, setDetailFine] = useState(null);
  const [detailRenewals, setDetailRenewals] = useState([]);

  const handleViewDetail = async (issueId) => {
    setDetailLoading(true);
    setDetailIssue(null);
    setDetailFine(null);
    setDetailRenewals([]);
    try {
      const [data, renewals, fines] = await Promise.all([
        getIssueById(issueId),
        getIssueRenewalsByIssueId(issueId).catch(() => []),
        libraryId ? getFinesByLibrary(libraryId).catch(() => []) : Promise.resolve([])
      ]);

      setDetailIssue(data || null);
      setDetailRenewals(safeArray(renewals));
      setDetailFine(
        safeArray(fines).find((fine) => String(fine.issue_id) === String(issueId)) || null
      );
    } catch {
      /* silently ignore — issue may still be shown from list data */
    } finally {
      setDetailLoading(false);
    }
  };

  const getIssuedByName = (issue) => {
    const fullName = `${issue.first_name || ''} ${issue.last_name || ''}`.trim();

    return (
      issue.member_name ||
      issue.full_name ||
      issue.parent_name ||
      issue.user_name ||
      fullName ||
      'Member'
    );
  };

  const getStudentName = (issue) => {
    return (
      issue.student_name ||
      issue.student_full_name ||
      issue.child_name ||
      '-'
    );
  };

  const getMemberType = (issue) => {
    const source = String(
      issue.member_source ||
        issue.membership_type ||
        issue.member_type ||
        ''
    ).toLowerCase();

    if (source === 'outsider') return 'Outsider';
    if (source === 'school_parent') return 'Parent';
    if (source === 'parent') return 'Parent';
    if (source === 'staff') return 'Staff';

    if (issue.student_id || issue.student_name) return 'Parent';

    return source ? source.replaceAll('_', ' ') : '-';
  };

  const getIssueBookName = (issue) => {
    return (
      issue.title ||
      issue.book_title ||
      issue.book_name ||
      issue.name ||
      'Book'
    );
  };

  const getCopyText = (issue) => {
    return issue.accession_no || issue.barcode || issue.book_copy_id || '-';
  };

  const getIssueMemberName = (issue) => {
    const fullName = `${issue.first_name || ''} ${issue.last_name || ''}`.trim();

    return (
      issue.member_name ||
      issue.full_name ||
      issue.parent_name ||
      issue.user_name ||
      fullName ||
      'Member'
    );
  };

  const getIssueStatus = (issue) => {
    return String(issue.issue_status || issue.status || 'issued').toLowerCase();
  };

  const activeCount = issues.filter(
    (issue) => getIssueStatus(issue) === 'issued'
  ).length;

  const overdueCount = issues.filter((issue) => {
    const status = getIssueStatus(issue);

    if (status === 'returned') return false;
    if (!issue.due_date) return false;

    return new Date(issue.due_date) < new Date();
  }).length;

  const issueExportColumns = [
    { header: 'Book', key: '__book' },
    { header: 'Member', key: '__member' },
    { header: 'Copy', key: '__copy' },
    { header: 'Due', key: '__due' },
    { header: 'Status', key: '__status' }
  ];

  const handleExportIssuesCSV = () => {
    const rows = issues.map((issue) => ({
      __book: getIssueBookName(issue),
      __member: getIssueMemberName(issue),
      __copy: getCopyText(issue),
      __due: issue.due_date ? String(issue.due_date).slice(0, 10) : '-',
      __status: getIssueStatus(issue)
    }));
    exportToCSV(issueExportColumns, rows, 'issued_books_list');
  };

  const filteredIssues = issues.filter((issue) => {
    const q = search.trim().toLowerCase();

    if (!q) return true;

    return [
      getIssuedByName(issue),
      getStudentName(issue),
      getMemberType(issue),
      getIssueBookName(issue),
      getCopyText(issue),
      issue.issue_date,
      issue.due_date,
      issue.issue_status,
      issue.membership_no,
      issue.admission_no
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase()
      .includes(q);
  });

  const totalPages = Math.max(1, Math.ceil(filteredIssues.length / ISSUE_PAGE_SIZE));
  const paginatedIssues = filteredIssues.slice(
    (page - 1) * ISSUE_PAGE_SIZE,
    page * ISSUE_PAGE_SIZE
  );

  useEffect(() => {
    setPage(1);
  }, [search]);

  useEffect(() => {
    if (page > totalPages) setPage(totalPages);
  }, [page, totalPages]);

  return (
    <aside className="ib-side-panel">
      <div className="ib-side-head">
        <div>
          <h5>Issued Books</h5>
          <span>{activeCount} active</span>
        </div>

        <button
          type="button"
          className="ib-side-refresh"
          onClick={onRefresh}
          disabled={loading}
          title="Refresh"
        >
          <i className={`ti ti-refresh ${loading ? 'spin' : ''}`} />
        </button>

        <button type="button" className="ib-side-refresh" onClick={handleExportIssuesCSV} title="Export CSV">
          <i className="ti ti-file-spreadsheet" />
        </button>
      </div>

      <div className="ib-side-stats">
        <div>
          <strong>{issues.length}</strong>
          <span>Total</span>
        </div>

        <div>
          <strong>{activeCount}</strong>
          <span>Issued</span>
        </div>

        <div className={overdueCount > 0 ? 'danger' : ''}>
          <strong>{overdueCount}</strong>
          <span>Overdue</span>
        </div>
      </div>

      <div className="ib-side-search">
        <i className="ti ti-search" />
        <input
          type="text"
          placeholder="Search issue..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="ib-issue-table-wrap" ref={tableWrapRef}>
        {loading && issues.length === 0 ? (
          <div className="ib-side-empty">
            <i className="ti ti-loader-2 spin" />
            <span>Loading issued books...</span>
          </div>
        ) : filteredIssues.length > 0 ? (
          <table className="ib-issue-table">
            <thead>
              <tr>
                <th>Book</th>
                <th>Issued By</th>
                <th>Student</th>
                <th>Type</th>
                <th>Copy</th>
                <th>Due</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {paginatedIssues.map((issue) => {
                const status = getIssueStatus(issue);
                const isOverdue =
                  status !== 'returned' &&
                  issue.due_date &&
                  new Date(issue.due_date) < new Date();

                return (
                  <tr key={issue.id}>
                    <td title={getIssueBookName(issue)}>
                      <span className="ib-cell-book">
                        {getIssueBookName(issue)}
                      </span>
                    </td>

                    <td title={getIssuedByName(issue)}>
                      <span className="ib-cell-member">
                        {getIssuedByName(issue)}
                      </span>

                      {issue.membership_no && (
                        <div className="small text-muted">
                          {issue.membership_no}
                        </div>
                      )}
                    </td>

                    <td title={getStudentName(issue)}>
                      <span className="ib-cell-member">
                        {getStudentName(issue)}
                      </span>

                      {issue.admission_no && (
                        <div className="small text-muted">
                          {issue.admission_no}
                        </div>
                      )}
                    </td>

                    <td>
                      <span className="ib-mini-status issued">
                        {getMemberType(issue)}
                      </span>
                    </td>

                    <td title={getCopyText(issue)}>
                      {getCopyText(issue)}
                    </td>

                    <td>
                      {issue.due_date
                        ? String(issue.due_date).slice(0, 10)
                        : '-'}
                    </td>

                    <td>
                      <span
                        className={`ib-mini-status ${
                          status === 'returned'
                            ? 'returned'
                            : isOverdue
                            ? 'overdue'
                            : 'issued'
                        }`}
                      >
                        {status === 'returned'
                          ? 'Returned'
                          : isOverdue
                          ? 'Overdue'
                          : 'Issued'}
                      </span>
                    </td>

                    <td style={{ whiteSpace: 'nowrap' }}>
                      <div className="ib-row-actions">
                        <button
                          type="button"
                          className="ib-row-action view"
                          title="View details"
                          onClick={() => handleViewDetail(issue.id)}
                        >
                          <i className="ti ti-info-circle" />
                        </button>
                        {status !== 'returned' && (
                          <button
                            type="button"
                            className="ib-row-action return"
                            title="Return book"
                            onClick={() => navigate(`${sectionBase}/issues/${issue.id}/return`)}
                          >
                            <i className="ti ti-arrow-back-up" />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <div className="ib-side-empty">
            <i className="ti ti-books-off" />
            <span>No issued book found</span>
          </div>
        )}
      </div>

      {filteredIssues.length > 0 && (
        <div className="ib-side-pagination">
          <Pagination
            page={page}
            totalPages={totalPages}
            totalItems={filteredIssues.length}
            itemLabel="issues"
            onPageChange={setPage}
          />
        </div>
      )}

      {/* Issue detail modal — strictly read-only: no form fields, scanner,
          member picker or issue/submit controls. Separate state from the
          Issue Book creation form above (form/members/copies/etc.), so
          opening this can never render that form's markup. */}
      {(detailLoading || detailIssue) && createPortal(
        <div
          style={{
            position: 'fixed', inset: 0, zIndex: 1060,
            background: 'rgba(0,0,0,0.45)', display: 'flex',
            alignItems: 'center', justifyContent: 'center', padding: 16
          }}
          onClick={() => setDetailIssue(null)}
        >
          <div
            style={{
              background: '#fff', borderRadius: 14, width: '100%', maxWidth: 540,
              maxHeight: '85vh', display: 'flex', flexDirection: 'column',
              boxShadow: '0 20px 60px rgba(0,0,0,.25)', overflow: 'hidden'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{
              flexShrink: 0,
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '14px 20px', borderBottom: '1px solid #e8edf5',
              background: 'linear-gradient(135deg,#2563eb,#1d4ed8)', color: '#fff'
            }}>
              <span style={{ fontWeight: 700, fontSize: 15 }}>
                <i className="ti ti-info-circle me-2" />Issue Details
              </span>
              <button
                type="button"
                onClick={() => setDetailIssue(null)}
                style={{ background: 'none', border: 'none', color: '#fff', fontSize: 20, cursor: 'pointer', lineHeight: 1 }}
              >×</button>
            </div>

            <div style={{ padding: '20px 24px', overflowY: 'auto', overflowX: 'hidden', flex: '1 1 auto', minHeight: 0 }}>
              {detailLoading ? (
                <div style={{ textAlign: 'center', padding: '32px 0', color: '#64748b' }}>
                  <i className="ti ti-loader-2 spin" style={{ fontSize: 28 }} />
                  <div style={{ marginTop: 8, fontSize: 13 }}>Loading details…</div>
                </div>
              ) : detailIssue ? (() => {
                const d = detailIssue;
                const fullName = `${d.first_name || ''} ${d.last_name || ''}`.trim();
                const memberName = d.member_name || d.full_name || d.parent_name || fullName || '-';
                const bookName = d.title || d.book_title || d.book_name || '-';
                const copyText = [d.accession_no, d.barcode].filter(Boolean).join(' / ') || d.book_copy_id || '-';
                const issuedByName = `${d.issued_by_first_name || ''} ${d.issued_by_last_name || ''}`.trim() || '-';
                const returnedToName = `${d.returned_to_first_name || ''} ${d.returned_to_last_name || ''}`.trim() || '-';
                const status = String(d.issue_status || d.status || 'issued').toLowerCase();
                const isOverdue = status !== 'returned' && d.due_date && new Date(d.due_date) < new Date();
                const statusLabel = status === 'returned' ? 'Returned' : isOverdue ? 'Overdue' : 'Issued';
                const statusColor = status === 'returned' ? '#16a34a' : isOverdue ? '#d97706' : '#2563eb';
                const fineAmount = detailFine ? Number(detailFine.amount || 0) : null;
                const fineStatus = detailFine?.fine_status ? String(detailFine.fine_status).replace(/_/g, ' ') : null;
                const rows = [
                  ['Issue ID', d.id ?? '-'],
                  ['Book', bookName],
                  ['Copy / Accession / Barcode', copyText],
                  ['Member', memberName],
                  ['Membership No', d.membership_no || '-'],
                  ['Member Type', getMemberType(d)],
                  ['Student', d.student_name || d.student_full_name || '-'],
                  ['Issue Source', d.issue_source || '-'],
                  ['Issue Date', d.issue_date ? String(d.issue_date).slice(0, 10) : '-'],
                  ['Due Date', d.due_date ? String(d.due_date).slice(0, 10) : '-'],
                  ['Return Date', d.return_date ? String(d.return_date).slice(0, 10) : '-'],
                  ['Renew Count', d.renew_count ?? '-'],
                  ['Book Condition', d.book_return_condition || '-'],
                  ['Remarks', d.remarks || '-'],
                  ['Issued By', issuedByName],
                  ['Returned To', status === 'returned' ? returnedToName : '-'],
                ];
                return (
                  <>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16, flexWrap: 'wrap' }}>
                      <span style={{
                        display: 'inline-block', padding: '3px 12px', borderRadius: 20,
                        fontSize: 12, fontWeight: 700, color: '#fff', background: statusColor
                      }}>{statusLabel}</span>
                      {isOverdue && (
                        <span style={{ fontSize: 12, color: '#d97706', fontWeight: 600 }}>
                          <i className="ti ti-clock-exclamation me-1" />
                          {Math.floor((new Date() - new Date(d.due_date)) / 86400000)} day(s) overdue
                        </span>
                      )}
                    </div>

                    <dl style={{ display: 'grid', gridTemplateColumns: 'minmax(120px, 40%) 1fr', rowGap: 8, columnGap: 8, margin: 0 }}>
                      {rows.map(([label, value]) => (
                        <React.Fragment key={label}>
                          <dt style={{ fontSize: 12, color: '#64748b', fontWeight: 600, margin: 0, paddingRight: 8, wordBreak: 'break-word' }}>{label}</dt>
                          <dd style={{ fontSize: 13, color: '#1e293b', margin: 0, wordBreak: 'break-word' }}>{value}</dd>
                        </React.Fragment>
                      ))}
                    </dl>

                    <div style={{
                      marginTop: 16, padding: '10px 12px', borderRadius: 10,
                      background: '#f8fafc', border: '1px solid #e2e8f0'
                    }}>
                      <div style={{ fontSize: 11.5, fontWeight: 700, color: '#475569', marginBottom: 6, textTransform: 'uppercase', letterSpacing: .3 }}>
                        Fine
                      </div>
                      {detailFine ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, flexWrap: 'wrap' }}>
                          <span style={{ fontWeight: 700, color: '#1e293b' }}>₹ {fineAmount}</span>
                          <span style={{
                            padding: '2px 10px', borderRadius: 12, fontSize: 11, fontWeight: 700, color: '#fff',
                            background: fineStatus === 'paid' ? '#16a34a' : fineStatus === 'waived' ? '#64748b' : '#dc2626',
                            textTransform: 'capitalize'
                          }}>{fineStatus}</span>
                        </div>
                      ) : (
                        <div style={{ fontSize: 13, color: '#94a3b8' }}>No fine recorded</div>
                      )}
                    </div>

                    {detailRenewals.length > 0 && (
                      <div style={{ marginTop: 16 }}>
                        <div style={{ fontSize: 11.5, fontWeight: 700, color: '#475569', marginBottom: 6, textTransform: 'uppercase', letterSpacing: .3 }}>
                          Renewal History
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                          {detailRenewals.map((renewal) => {
                            const renewedByName = `${renewal.renewed_by_first_name || ''} ${renewal.renewed_by_last_name || ''}`.trim();
                            return (
                              <div
                                key={renewal.id}
                                style={{
                                  fontSize: 12.5, color: '#1e293b', padding: '8px 10px', borderRadius: 8,
                                  background: '#f8fafc', border: '1px solid #e2e8f0', wordBreak: 'break-word'
                                }}
                              >
                                <div>
                                  {renewal.old_due_date ? String(renewal.old_due_date).slice(0, 10) : '-'}
                                  {' → '}
                                  {renewal.new_due_date ? String(renewal.new_due_date).slice(0, 10) : '-'}
                                </div>
                                <div style={{ color: '#94a3b8', fontSize: 11.5, marginTop: 2 }}>
                                  Renewed on {renewal.created_at ? String(renewal.created_at).slice(0, 10) : '-'}
                                  {renewedByName ? ` by ${renewedByName}` : ''}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}

                    {status !== 'returned' && (
                      <div style={{ marginTop: 20, textAlign: 'right' }}>
                        <button
                          type="button"
                          className="ib-modal-btn-primary"
                          onClick={() => { setDetailIssue(null); navigate(`${sectionBase}/issues/${d.id}/return`); }}
                        >
                          <i className="ti ti-arrow-back-up" />Return Book
                        </button>
                      </div>
                    )}
                  </>
                );
              })() : null}
            </div>
          </div>
        </div>,
        document.body
      )}
    </aside>
  );
};

const IssueBook = () => {
  const navigate = useNavigate();
  const sectionBase = useSectionBase();
  const location = useLocation();
  const { user } = useAuth();

  const libraryId = useActiveLibraryId();
  const staffId = user?.id || user?.staff_id;

  const memberScanRef = useRef(null);
  const scanRef = useRef(null);
  const scanBufferRef = useRef('');
  const lastScanKeyTimeRef = useRef(0);

  const focusMemberScanner = () => {
    setTimeout(() => {
      console.log('[SCAN][FOCUS] Member scanner focused');
      memberScanRef.current?.focus({ preventScroll: true });
    }, 150);
  };

  const focusBookScanner = () => {
    setTimeout(() => {
      console.log('[SCAN][FOCUS] Book scanner focused');
      scanRef.current?.focus({ preventScroll: true });
    }, 150);
  };

  const focusScanner = focusBookScanner;

  const [loading, setLoading] = useState(false);
  const [scanVal, setScanVal] = useState('');
  const [memberScanVal, setMemberScanVal] = useState('');

  const [members, setMembers] = useState([]);
  const [books, setBooks] = useState([]);
  const [copies, setCopies] = useState([]);
  const [readyRequests, setReadyRequests] = useState([]);

  const [issuedBooks, setIssuedBooks] = useState([]);
  const [issueListLoading, setIssueListLoading] = useState(false);
  const [issueSearch, setIssueSearch] = useState('');

  const [memberInfo, setMemberInfo] = useState(null);
  const [memberFines, setMemberFines] = useState([]);
  const [fineLoading, setFineLoading] = useState(false);

  const [bookInfo, setBookInfo] = useState(null);
  const [copiesLoading, setCopiesLoading] = useState(false);

  const [form, setForm] = useState({
    issue_source: 'direct',
    reservation_id: '',
    membership_id: '',
    member_id: '',
    student_id: '',
    book_id: '',
    book_copy_id: '',
    issue_date: today(),
    due_date: defaultDue(),
    remarks: ''
  });

  // This form must always render from the top — whatever scrollY the
  // previous page (or previously active tab) left behind otherwise makes it
  // look like the page opened halfway down. Runs on every mount, which
  // includes switching back to this tab (renderContent() swaps to a
  // different component type in between, so this fully unmounts/remounts).
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, []);

  useEffect(() => {
    focusMemberScanner();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const fetchIssuedBooks = async () => {
    if (!libraryId) return;

    try {
      setIssueListLoading(true);

      const data = await getIssuesByLibrary(libraryId);
      setIssuedBooks(safeArray(data));
    } catch (error) {
      setIssuedBooks([]);
    } finally {
      setIssueListLoading(false);
    }
  };

  const fetchInitialData = async () => {
    if (!libraryId) return;

    try {
      setLoading(true);

      const [memberData, bookData] = await Promise.all([
        getMembersByLibrary(libraryId),
        getBooksByLibrary(libraryId)
      ]);

      setMembers(safeArray(memberData).map(normalizeMember));
      setBooks(safeArray(bookData).map(normalizeBook));

      try {
        const reservationData = await getReservationsByStatus(
          libraryId,
          'ready_for_pickup'
        );

        setReadyRequests(safeArray(reservationData));
      } catch (error) {
        setReadyRequests([]);
      }
    } catch (error) {
      Swal.fire('Error', getErrorMessage(error), 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const warm = readPrefetched(ISSUES_RESOURCE, libraryId);
    if (warm) setIssuedBooks(safeArray(warm));

    fetchInitialData();
    fetchIssuedBooks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [libraryId]);

  useEffect(() => {
    setTimeout(() => {
      console.log('[SCAN][INIT-2] Member scanner focused after load');
      memberScanRef.current?.focus({ preventScroll: true });
    }, 300);
  }, []);

  const fetchCopies = async (bookId) => {
    if (!bookId) {
      setCopies([]);
      return;
    }

    try {
      setCopiesLoading(true);

      const data = await getAvailableCopiesByBookId(bookId);
      const normalizedCopies = safeArray(data).map(normalizeCopy);

      setCopies(normalizedCopies);
    } catch (error) {
      setCopies([]);
      Swal.fire('Error', getErrorMessage(error), 'error');
    } finally {
      setCopiesLoading(false);
    }
  };

  const fetchMemberFines = async (memberId) => {
    if (!memberId) {
      setMemberFines([]);
      return;
    }

    try {
      setFineLoading(true);

      const data = await getMemberFines(memberId).catch(() => []);

      const pendingFines = safeArray(data).filter((fine) => {
        const status = getFineStatus(fine);

        return (
          status === 'pending' ||
          status === 'unpaid' ||
          status === 'partially_paid'
        );
      });

      setMemberFines(pendingFines);
    } catch (error) {
      setMemberFines([]);
    } finally {
      setFineLoading(false);
    }
  };
  const processMemberScan = useCallback(
    async (rawCode) => {
      const scanned = String(rawCode || '').trim();

      console.log('[MEMBER_SCAN][RAW]', rawCode);
      console.log('[MEMBER_SCAN][CLEANED]', {
        scanned,
        libraryId
      });

      if (!scanned) {
        console.warn('[MEMBER_SCAN][EMPTY]');
        return;
      }

      if (/^(BAR|ACC)-/i.test(scanned)) {
        console.warn('[MEMBER_SCAN][WRONG_BOOK_BARCODE_IN_MEMBER_FIELD]', scanned);

        Swal.fire(
          'Wrong Scan',
          'This is a book barcode. Please scan member library card QR in this field.',
          'warning'
        );

        setMemberScanVal('');
        focusBookScanner();

        return;
      }

      if (!libraryId) {
        console.error('[MEMBER_SCAN][NO_LIBRARY_ID]');
        Swal.fire('Error', 'Library ID not found', 'error');
        return;
      }

      try {
        setLoading(true);

        console.log('[MEMBER_SCAN][API_CALL]', {
          url: `/members/scan/${libraryId}/${encodeURIComponent(scanned)}`,
          scanned
        });

        const scannedMemberData = await getMemberByScanCode(libraryId, scanned);

        console.log('[MEMBER_SCAN][API_RESPONSE]', scannedMemberData);

        const normalizedScannedMember = normalizeMember(scannedMemberData);

        console.log('[MEMBER_SCAN][NORMALIZED]', normalizedScannedMember);

        if (!normalizedScannedMember.id) {
          console.error('[MEMBER_SCAN][INVALID_RESPONSE]', scannedMemberData);

          Swal.fire(
            'Error',
            'Invalid member scan response. Member ID missing.',
            'error'
          );
          return;
        }

        setMemberInfo(normalizedScannedMember);

        setMembers((prevMembers) => {
          const alreadyExists = prevMembers.some(
            (member) => String(member.id) === String(normalizedScannedMember.id)
          );

          if (alreadyExists) {
            return prevMembers.map((member) =>
              String(member.id) === String(normalizedScannedMember.id)
                ? normalizedScannedMember
                : member
            );
          }

          return [normalizedScannedMember, ...prevMembers];
        });

        setForm((prev) => {
          const nextForm = {
            ...prev,
            member_id: normalizedScannedMember.id,
            membership_id:
              normalizedScannedMember.membership_id ||
              normalizedScannedMember.active_membership_id ||
              '',
            student_id:
              normalizedScannedMember.student_id ||
              normalizedScannedMember.linked_student_id ||
              ''
          };

          console.log('[MEMBER_SCAN][FORM_UPDATE]', nextForm);

          return nextForm;
        });

        fetchMemberFines(normalizedScannedMember.id);

        Swal.fire({
          icon: 'success',
          title: 'Member Found',
          html: `
            <b>${getFullName(normalizedScannedMember)}</b><br/>
            Mobile: ${getMobile(normalizedScannedMember) || '-'}<br/>
            Membership: ${
              normalizedScannedMember.membership_no ||
              normalizedScannedMember.membership_id ||
              '-'
            }
          `,
          timer: 1300,
          showConfirmButton: false
        });

        console.log('[MEMBER_SCAN][NEXT_FOCUS] Book scanner focused');
        focusBookScanner();
      } catch (error) {
        console.error('[MEMBER_SCAN][ERROR]', {
          error,
          response: error?.response?.data,
          message: error?.message
        });

        Swal.fire('Member Not Found', getErrorMessage(error), 'warning');
      } finally {
        setLoading(false);
        setMemberScanVal('');
      }
    },
    [libraryId]
  );

  const handleMemberScan = async (e) => {
    console.log('[MEMBER_SCAN][KEYDOWN]', {
      key: e.key,
      memberScanVal,
      activeElement: document.activeElement?.tagName,
      libraryId
    });

    if (e.key !== 'Enter') return;

    e.preventDefault();
    await processMemberScan(memberScanVal);
  };

  const onSourceChange = (value) => {
    setForm({
      issue_source: value,
      reservation_id: '',
      membership_id: '',
      member_id: '',
      student_id: '',
      book_id: '',
      book_copy_id: '',
      issue_date: today(),
      due_date: defaultDue(),
      remarks: ''
    });

    setMemberInfo(null);
    setBookInfo(null);
    setCopies([]);
    setMemberFines([]);
  };

  const onMemberSelect = (id) => {
  const selectedMember = members.find(
    (item) => String(item.id) === String(id)
  );

  setMemberInfo(selectedMember || null);

  setForm((prev) => ({
    ...prev,
    member_id: id,
    membership_id:
      selectedMember?.membership_id ||
      selectedMember?.active_membership_id ||
      '',
    student_id:
      selectedMember?.student_id ||
      selectedMember?.linked_student_id ||
      ''
  }));

  fetchMemberFines(id);
  focusBookScanner();
};

  const onBookSelect = (id) => {
    const selectedBook = books.find(
      (item) => String(item.id) === String(id)
    );

    setBookInfo(selectedBook || null);

    setForm((prev) => ({
      ...prev,
      book_id: id,
      book_copy_id: ''
    }));

    fetchCopies(id);
  };

  const onReservationSelect = async (value, fallbackReservation = null) => {
    const selectedRequest =
      readyRequests.find((item) => String(item.id) === String(value)) ||
      (fallbackReservation && String(fallbackReservation.id) === String(value)
        ? fallbackReservation
        : null);

    if (!selectedRequest) {
      setForm((prev) => ({
        ...prev,
        reservation_id: value
      }));
      return;
    }

    const copyId =
      selectedRequest.reserved_copy_id ||
      selectedRequest.book_copy_id ||
      selectedRequest.copy_id ||
      '';

    const selectedMember = members.find(
      (item) => String(item.id) === String(selectedRequest.member_id)
    );

    const selectedBook = books.find(
      (item) => String(item.id) === String(selectedRequest.book_id)
    );

    setForm((prev) => ({
      ...prev,
      reservation_id: selectedRequest.id,
      membership_id:
        selectedRequest.membership_id ||
        selectedMember?.membership_id ||
        selectedMember?.active_membership_id ||
        '',
      member_id: selectedRequest.member_id || '',
      student_id: selectedRequest.student_id || selectedMember?.student_id || '',
      book_id: selectedRequest.book_id || '',
      book_copy_id: copyId
    }));

    setMemberInfo(selectedMember || null);
    setBookInfo(selectedBook || null);

    if (selectedRequest.book_id) {
      await fetchCopies(selectedRequest.book_id);
    }

    if (selectedRequest.member_id) {
      fetchMemberFines(selectedRequest.member_id);
    }
  };

  useEffect(() => {
    const reservationId = location.state?.reservationId;
    const fallbackReservation = location.state?.reservation || null;

    if (!reservationId) return;
    // Wait for the ready list to load, unless we were handed the reservation.
    if (readyRequests.length === 0 && !fallbackReservation) return;

    setForm((prev) => ({ ...prev, issue_source: 'parent_request' }));
    onReservationSelect(reservationId, fallbackReservation);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [readyRequests, location.state]);

  const processScan = useCallback(
    async (rawCode) => {
      console.log('[BOOK_SCAN][RAW]', rawCode);

      const scanned = String(rawCode || '').trim();

      console.log('[BOOK_SCAN][CLEANED]', {
        scanned,
        libraryId
      });

      if (!scanned) {
        console.warn('[BOOK_SCAN][EMPTY]');
        return;
      }

      if (/^LIB-\d+/i.test(scanned)) {
        console.warn('[BOOK_SCAN][MEMBER_CARD_IN_BOOK_FIELD]', scanned);

        Swal.fire(
          'Wrong Scan',
          'This is a member card. Please scan book barcode in book field.',
          'warning'
        );

        setScanVal('');
        focusMemberScanner();

        return;
      }

      if (!libraryId) {
        console.error('[BOOK_SCAN][NO_LIBRARY_ID]');
        Swal.fire('Error', 'Library ID not found', 'error');
        return;
      }

      try {
        setLoading(true);

        console.log('[BOOK_SCAN][API_CALL]', {
          url: `/book-copies/scan/${libraryId}/${encodeURIComponent(scanned)}`,
          scanned
        });

        const scannedCopyData = await getCopyByScanCode(libraryId, scanned);

        console.log('[BOOK_SCAN][API_RESPONSE]', scannedCopyData);

        const normalizedCopy = normalizeCopy(scannedCopyData);

        const scannedBook = normalizeBook({
          id: scannedCopyData.book_id || scannedCopyData.Book_ID,
          title:
            scannedCopyData.title ||
            scannedCopyData.book_title ||
            scannedCopyData.name ||
            'Book',
          book_title: scannedCopyData.book_title || scannedCopyData.title,
          author_name: scannedCopyData.author_name,
          publisher_name: scannedCopyData.publisher_name,
          isbn: scannedCopyData.isbn,
          category_name: scannedCopyData.category_name,
          total_copies: scannedCopyData.total_copies,
          issued_copies: scannedCopyData.issued_copies,
          reserved_copies: scannedCopyData.reserved_copies
        });

        console.log('[BOOK_SCAN][NORMALIZED]', {
          book: scannedBook,
          copy: normalizedCopy
        });

        if (!scannedBook.id || !normalizedCopy.id) {
          console.error('[BOOK_SCAN][INVALID_RESPONSE]', scannedCopyData);

          Swal.fire(
            'Error',
            'Invalid scan response. Book ID or copy ID missing.',
            'error'
          );
          return;
        }

        setBookInfo(scannedBook);
        setCopies([normalizedCopy]);

        setBooks((prevBooks) => {
          const alreadyExists = prevBooks.some(
            (book) => String(book.id) === String(scannedBook.id)
          );

          if (alreadyExists) return prevBooks;

          return [scannedBook, ...prevBooks];
        });

        setForm((prev) => {
          const nextForm = {
            ...prev,
            book_id: scannedBook.id,
            book_copy_id: normalizedCopy.id
          };

          console.log('[BOOK_SCAN][FORM_UPDATE]', nextForm);

          return nextForm;
        });

        Swal.fire({
          icon: 'success',
          title: 'Book Found',
          html: `
            <b>${scannedBook.title || '-'}</b><br/>
            Accession: ${normalizedCopy.accession_no || '-'}<br/>
            Barcode: ${normalizedCopy.barcode || '-'}
          `,
          timer: 1400,
          showConfirmButton: false
        });
      } catch (error) {
        console.error('[BOOK_SCAN][ERROR]', {
          error,
          response: error?.response?.data,
          message: error?.message
        });

        Swal.fire('Not Found', getErrorMessage(error), 'warning');
      } finally {
        setLoading(false);
        setScanVal('');
        focusBookScanner();
      }
    },
    [libraryId]
  );

  const handleScan = async (e) => {
    console.log('[BOOK_SCAN][KEYDOWN]', {
      key: e.key,
      scanVal,
      activeElement: document.activeElement?.tagName,
      libraryId
    });

    if (e.key !== 'Enter') return;

    e.preventDefault();
    await processScan(scanVal);
  };

  useEffect(() => {
    const handleGlobalScanner = (e) => {
      if (e.ctrlKey || e.altKey || e.metaKey) return;
      if (!e.key) return;

      const activeElement = document.activeElement;

      if (activeElement === scanRef.current || activeElement === memberScanRef.current) {
        return;
      }

      const tagName = String(activeElement?.tagName || '').toLowerCase();
      const isEditableField =
        tagName === 'input' ||
        tagName === 'textarea' ||
        tagName === 'select' ||
        activeElement?.isContentEditable;

      // Do not disturb normal typing in other form fields.
      if (isEditableField) {
        return;
      }

      const now = Date.now();

      if (now - lastScanKeyTimeRef.current > 100) {
        scanBufferRef.current = '';
      }

      lastScanKeyTimeRef.current = now;

      if (e.key === 'Enter') {
        const scanned = scanBufferRef.current.trim();
        scanBufferRef.current = '';

        console.log('[GLOBAL_SCAN][ENTER]', {
          scanned,
          activeElement: activeElement?.tagName
        });

        if (scanned.length >= 3) {
          e.preventDefault();

          if (/^(BAR|ACC)-/i.test(scanned)) {
            console.log('[GLOBAL_SCAN][ROUTE] Book scan');
            processScan(scanned);
          } else {
            console.log('[GLOBAL_SCAN][ROUTE] Member scan');
            processMemberScan(scanned);
          }
        }

        return;
      }

      if (e.key.length === 1) {
        scanBufferRef.current += e.key;

        console.log('[GLOBAL_SCAN][BUFFER]', scanBufferRef.current);
      }
    };

    document.addEventListener('keydown', handleGlobalScanner, true);

    return () => {
      document.removeEventListener('keydown', handleGlobalScanner, true);
    };
  }, [processScan, processMemberScan]);

  const availableCopies = useMemo(() => {
    return copies.filter(isCopyAvailable);
  }, [copies]);

  const selectedCopy = copies.find(
    (copy) => String(copy.id) === String(form.book_copy_id)
  );

  const pendingFineTotal = memberFines.reduce(
    (sum, fine) => sum + getFineAmount(fine),
    0
  );

  const availableCopyCount = availableCopies.length;

  const memberOptionsCount = useMemo(() => members.length, [members]);

  const memberActiveIssueCount = useMemo(() => {
    if (!form.member_id) return 0;

    return issuedBooks.filter((issue) => {
      const status = String(issue.issue_status || issue.status || 'issued').toLowerCase();
      return (
        String(issue.member_id) === String(form.member_id) &&
        status !== 'returned'
      );
    }).length;
  }, [issuedBooks, form.member_id]);

  const getFineBadge = (status) => {
    if (status === 'paid') return 'bg-success';
    if (status === 'unpaid') return 'bg-danger';
    if (status === 'pending') return 'bg-danger';
    if (status === 'partially_paid') return 'bg-warning text-dark';
    if (status === 'waived') return 'bg-secondary';
    return 'bg-light text-dark';
  };

  const validateForm = () => {
    if (!libraryId) {
      Swal.fire('Error', 'Library ID not found', 'error');
      return false;
    }

    if (form.issue_source === 'parent_request' && !form.reservation_id) {
      Swal.fire('Error', 'Please select parent request', 'error');
      return false;
    }

    if (!form.member_id) {
      Swal.fire('Error', 'Please select a member', 'error');
      return false;
    }

    if (memberActiveIssueCount >= MAX_ISSUE_LIMIT) {
      Swal.fire(
        'Issue Limit Reached',
        `This member already has ${memberActiveIssueCount} book(s) issued. Maximum allowed is ${MAX_ISSUE_LIMIT}. Please return a book before issuing a new one.`,
        'error'
      );
      return false;
    }

    if (!form.book_id) {
      Swal.fire('Error', 'Please select a book', 'error');
      return false;
    }

    if (!form.book_copy_id) {
      Swal.fire('Error', 'Please select a book copy', 'error');
      return false;
    }

    if (form.issue_source !== 'parent_request') {
      const selectedAvailableCopy = availableCopies.find(
        (copy) => String(copy.id) === String(form.book_copy_id)
      );

      if (!selectedAvailableCopy) {
        Swal.fire(
          'Error',
          'Selected book copy is not available. Please select another copy.',
          'error'
        );
        return false;
      }
    }

    if (!form.issue_date || !form.due_date) {
      Swal.fire('Error', 'Issue date and due date are required', 'error');
      return false;
    }

    if (new Date(form.due_date) < new Date(form.issue_date)) {
      Swal.fire('Error', 'Due date cannot be before issue date', 'error');
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    if (pendingFineTotal > MAX_FINE_LIMIT) {
      Swal.fire(
        'Fine Limit Exceeded',
        `This member has pending fines of ₹ ${pendingFineTotal.toFixed(2)}, which exceeds the allowed limit of ₹ ${MAX_FINE_LIMIT.toFixed(2)}. Fines must be paid before issuing a new book.`,
        'error'
      );
      return;
    }

    if (memberFines.length > 0) {
      const { isConfirmed } = await Swal.fire({
        icon: 'warning',
        title: 'Pending Fines Found',
        html: `
          This member has pending fine amount:
          <b>₹ ${pendingFineTotal.toFixed(2)}</b><br/>
          Do you still want to issue this book?
        `,
        showCancelButton: true,
        confirmButtonText: 'Yes, Issue Anyway',
        cancelButtonText: 'Cancel'
      });

      if (!isConfirmed) return;
    }

    try {
      setLoading(true);

      await addIssue({
        library_id: libraryId,
        membership_id: form.membership_id || null,
        member_id: form.member_id,
        student_id: form.student_id || null,
        reservation_id:
          form.issue_source === 'parent_request'
            ? form.reservation_id || null
            : null,
        book_copy_id: form.book_copy_id,
        issued_by_staff_id: staffId || null,
        returned_to_staff_id: null,
        issue_date: form.issue_date,
        due_date: form.due_date,
        return_date: null,
        renew_count: 0,
        issue_status: 'issued',
        book_return_condition: null,
        issue_source: form.issue_source,
        remarks: form.remarks || null
      });

      await Swal.fire({
        icon: 'success',
        title: 'Book Issued',
        text: 'Book issued successfully',
        timer: 1500,
        showConfirmButton: false
      });

      await fetchIssuedBooks();

      setForm((prev) => ({
        ...prev,
        book_id: '',
        book_copy_id: '',
        remarks: '',
        issue_date: today(),
        due_date: defaultDue()
      }));

      setBookInfo(null);
      setCopies([]);
      setScanVal('');
    } catch (error) {
      Swal.fire('Error', getErrorMessage(error), 'error');
    } finally {
      setLoading(false);
    }
  };

  

  return (
    <div className="ib-page">
      <div className="lib-page-header">
        <div className="lib-page-header__left">
          <div className="lib-page-header__icon">
            <i className="fas fa-book-reader" />
          </div>
          <div>
            <h3 className="lib-page-header__title">Issue Book</h3>
            <div className="lib-page-header__subtitle">Issue book directly, via approved parent request, or as a staff issue</div>
          </div>
        </div>
        <div className="lib-page-header__actions">
          <button
            type="button"
            className="ib-btn-cancel"
            onClick={() => navigate(`${sectionBase}/issues`)}
          >
            <i className="ti ti-arrow-left" /> Back
          </button>
        </div>
      </div>

      <div className="ib-workspace">
        <div className="ib-form-main">
          <form onSubmit={handleSubmit}>
            <div className="ib-card">
              <div className="ib-card-head">
                <i className="ti ti-source-code" /> Issue Source
              </div>

              <div className="ib-card-body">
                <div className="ib-grid-3">
                  <div className={`ib-field ${form.issue_source === 'parent_request' ? '' : 'ib-col-3'}`}>
                    <label>
                      Issue Source <span>*</span>
                    </label>

                    <div className="ib-radio-group">
                      {[
                        ['direct', 'Direct Issue'],
                        ['parent_request', 'Parent Request'],
                        ['staff_issue', 'Staff Issue']
                      ].map(([value, label]) => (
                        <label
                          key={value}
                          className={`ib-radio ${
                            form.issue_source === value ? 'active' : ''
                          }`}
                        >
                          <input
                            type="radio"
                            name="issue_source"
                            value={value}
                            checked={form.issue_source === value}
                            onChange={() => onSourceChange(value)}
                          />
                          {label}
                        </label>
                      ))}
                    </div>
                  </div>

                  {form.issue_source === 'parent_request' && (
                    <div className="ib-field ib-col-2">
                      <label>
                        Approved Parent Request <span>*</span>
                      </label>

                      <SharedSearchableSelect
                        name="reservation_id"
                        value={form.reservation_id}
                        onChange={(e) => onReservationSelect(e.target.value)}
                        options={readyRequests.map((request) => ({
                          value: request.id,
                          label: `${
                            request.member_name || request.parent_name || 'Member'
                          } — ${request.title || request.book_title || 'Book'} — Copy: ${
                            request.accession_no || request.barcode || '-'
                          }`
                        }))}
                        placeholder="Select Ready For Pickup Request"
                        noOptionsMessage="No ready parent requests found"
                        className="ib-select-native"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="ib-card">
              <div className="ib-card-head">
                <i className="ti ti-user" /> Member Details & Fine Details
              </div>
              <div className="ib-scan-bar mb-3" onClick={focusMemberScanner}>
  <i className="ti ti-id-badge" />

  <input
    ref={memberScanRef}
    type="text"
    placeholder="Scan member library card QR / Member ID"
    value={memberScanVal}
    onChange={(e) => {
      console.log('[MEMBER_SCAN][INPUT_CHANGE]', e.target.value);
      setMemberScanVal(e.target.value);
    }}
    onKeyDown={handleMemberScan}
    disabled={form.issue_source === 'parent_request'}
  />

  {memberScanVal && (
    <button
      type="button"
      className="ib-scan-clear"
      onClick={() => {
        setMemberScanVal('');
        setTimeout(() => memberScanRef.current?.focus(), 100);
      }}
    >
      <i className="ti ti-x" />
    </button>
  )}

  <span className="ib-scan-hint">Scan member card</span>
              </div>

              <div className="ib-card-body">
                <div className="ib-grid-3">
                  <div className="ib-field">
                    <label>
                      Member <span>*</span>
                    </label>

                    <SharedSearchableSelect
                      name="member_id"
                      options={members.map((member) => ({
                        value: member.id,
                        label: getMobile(member)
                          ? `${getFullName(member)} - ${getMobile(member)}`
                          : getFullName(member)
                      }))}
                      value={form.member_id}
                      onChange={(e) => onMemberSelect(e.target.value)}
                      placeholder={
                        memberOptionsCount > 0
                          ? 'Search & select member...'
                          : 'No active member found'
                      }
                      disabled={form.issue_source === 'parent_request'}
                    />

                    <div className="small text-muted mt-1">
                      {loading
                        ? 'Loading members...'
                        : `${memberOptionsCount} member(s) loaded`}
                    </div>
                  </div>

                  <div className="ib-field">
                    <label>Membership ID</label>
                    <input
                      className="ib-input disabled"
                      value={form.membership_id || ''}
                      readOnly
                    />
                  </div>

                  <div className="ib-field">
                    <label>Student ID</label>
                    <input
                      className="ib-input disabled"
                      value={form.student_id || ''}
                      readOnly
                    />
                  </div>
                </div>

                {memberInfo && (
                  <div className="ib-member-panel">
                    <div className="ib-member-avatar">
                      {memberInfo.photo ? (
                        <img src={memberInfo.photo} alt="member" />
                      ) : (
                        <div className="ib-member-initials">
                          {getFullName(memberInfo).charAt(0).toUpperCase()}
                        </div>
                      )}
                    </div>

                    <div className="ib-member-details">
                      <div className="ib-member-name">
                        {getFullName(memberInfo)}
                      </div>

                      <div className="ib-member-meta">
                        {getMobile(memberInfo) && (
                          <span>
                            <i className="ti ti-phone" /> {getMobile(memberInfo)}
                          </span>
                        )}

                        {memberInfo.email && (
                          <span>
                            <i className="ti ti-mail" /> {memberInfo.email}
                          </span>
                        )}

                        {memberInfo.membership_type && (
                          <span>
                            <i className="ti ti-id-badge" />{' '}
                            {memberInfo.membership_type}
                          </span>
                        )}

                        {memberInfo.membership_no && (
                          <span>
                            <i className="ti ti-credit-card" />{' '}
                            {memberInfo.membership_no}
                          </span>
                        )}

                        {memberInfo.address && (
                          <span>
                            <i className="ti ti-map-pin" /> {memberInfo.address}
                          </span>
                        )}
                      </div>

                      <div className="ib-member-badges">
                        {memberInfo.membership_no && (
                          <span className="ib-badge blue">
                            Membership No.: {memberInfo.membership_no}
                          </span>
                        )}

                        {memberInfo.student_id && (
                          <span className="ib-badge teal">
                            Student: {memberInfo.student_id}
                          </span>
                        )}

                        {memberInfo.status && (
                          <span
                            className={`ib-badge ${
                              memberInfo.status === 'active' ? 'green' : 'gray'
                            }`}
                          >
                            {memberInfo.status}
                          </span>
                        )}
                      </div>
                    </div>

                    {fineLoading && (
                      <div className="ib-fine-loading">Checking fines...</div>
                    )}

                    {!fineLoading && memberFines.length > 0 && (
                      <div className="ib-fine-alert">
                        <i className="ti ti-alert-triangle" />

                        <div>
                          <strong>
                            Pending Fines: ₹ {pendingFineTotal.toFixed(2)}
                          </strong>
                          <div>
                            {memberFines.length} unpaid fine
                            {memberFines.length > 1 ? 's' : ''} found
                          </div>
                        </div>
                      </div>
                    )}

                    {!fineLoading && memberFines.length === 0 && (
                      <div className="ib-fine-clear">
                        <i className="ti ti-circle-check" /> No pending fines
                      </div>
                    )}
                  </div>
                )}

                {memberInfo && memberFines.length > 0 && (
                  <div className="mt-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h6 className="mb-0">Pending Fine List</h6>
                      <strong className="text-danger">
                        Total: ₹ {pendingFineTotal.toFixed(2)}
                      </strong>
                    </div>

                    <div className="table-responsive">
                      <table className="table table-sm table-bordered align-middle">
                        <thead className="table-light">
                          <tr>
                            <th>#</th>
                            <th>Fine Type</th>
                            <th>Amount</th>
                            <th>Paid</th>
                            <th>Balance</th>
                            <th>Reason</th>
                            <th>Status</th>
                            <th>Created</th>
                          </tr>
                        </thead>

                        <tbody>
                          {memberFines.map((fine, index) => (
                            <tr key={fine.id || index}>
                              <td>{index + 1}</td>

                              <td className="text-capitalize">
                                {fine.fine_type || '-'}
                              </td>

                              <td>₹ {fine.amount || fine.fine_amount || 0}</td>

                              <td>₹ {fine.paid_amount || 0}</td>

                              <td>₹ {getFineAmount(fine).toFixed(2)}</td>

                              <td>{fine.reason || fine.remarks || '-'}</td>

                              <td>
                                <span
                                  className={`badge ${getFineBadge(
                                    getFineStatus(fine)
                                  )}`}
                                >
                                  {getFineStatus(fine) || '-'}
                                </span>
                              </td>

                              <td>
                                {fine.created_at
                                  ? String(fine.created_at).slice(0, 10)
                                  : '-'}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="ib-card">
              <div className="ib-card-head">
                <i className="ti ti-book" /> Book Details
              </div>

              <div className="ib-card-body">
               <div className="ib-scan-bar" onClick={focusScanner}>
                  <i className="ti ti-barcode" />

                  <input
                    ref={scanRef}
                    type="text"
                    placeholder="Scan barcode / accession no to auto-select book copy"
                    value={scanVal}
                    onChange={(e) => {
                      console.log('[BOOK_SCAN][INPUT_CHANGE]', e.target.value);
                      setScanVal(e.target.value);
                    }}
                    onKeyDown={handleScan}
                    autoFocus
                  />

                  {scanVal && (
                    <button
                      type="button"
                      className="ib-scan-clear"
                      onClick={() => {
                        setScanVal('');
                        focusScanner();
                      }}
                    >
                      <i className="ti ti-x" />
                    </button>
                  )}

                  {!form.book_id && (
                    <span className="ib-scan-hint">Scan barcode to auto-select book</span>
                  )}
                </div>

                <div className="ib-grid-2" style={{ marginTop: 14 }}>
                  <div className="ib-field">
                    <label>
                      Book <span>*</span>
                    </label>

                    <SharedSearchableSelect
                      name="book_id"
                      options={books.map((book) => ({
                        value: book.id,
                        label: book.author_name ? `${book.title} - ${book.author_name}` : book.title
                      }))}
                      value={form.book_id}
                      onChange={(e) => onBookSelect(e.target.value)}
                      placeholder="Search & select book..."
                      disabled={form.issue_source === 'parent_request'}
                    />
                  </div>

                  <div className="ib-field">
                    <label>
                      Book Copy <span>*</span>

                      {form.book_id && !copiesLoading && (
                        <span
                          className={`ib-copies-badge ${
                            availableCopyCount === 0 ? 'none' : ''
                          }`}
                        >
                          {availableCopyCount} available
                        </span>
                      )}

                      {copiesLoading && (
                        <span className="ib-copies-loading">Loading...</span>
                      )}
                    </label>

                    <SharedSearchableSelect
                      name="book_copy_id"
                      value={form.book_copy_id}
                      onChange={(e) =>
                        setForm((prev) => ({
                          ...prev,
                          book_copy_id: e.target.value
                        }))
                      }
                      options={[
                        ...availableCopies.map((copy) => ({
                          value: copy.id,
                          label: `${copy.accession_no || '-'} | ${copy.barcode || '-'} | Copy ${
                            copy.copy_number || '-'
                          }`
                        })),
                        ...(form.issue_source === 'parent_request' &&
                        form.book_copy_id &&
                        !copies.some(
                          (copy) => String(copy.id) === String(form.book_copy_id)
                        )
                          ? [
                              {
                                value: form.book_copy_id,
                                label: `Assigned Copy #${form.book_copy_id}`
                              }
                            ]
                          : [])
                      ]}
                      placeholder="Select Copy"
                      disabled={availableCopyCount === 0 && !form.book_copy_id}
                      className="ib-select-native"
                    />
                  </div>
                </div>

                {bookInfo && (
                  <div className="ib-book-panel">
                    <div className="ib-book-spine">
                      <i className="ti ti-book-2" />
                    </div>

                    <div className="ib-book-details">
                      <div className="ib-book-title">
                        {bookInfo.title || bookInfo.book_title || '-'}
                      </div>

                      {bookInfo.subtitle && (
                        <div className="ib-book-subtitle">
                          {bookInfo.subtitle}
                        </div>
                      )}

                      <div className="ib-book-meta">
                        {bookInfo.author_name && (
                          <span>
                            <i className="ti ti-user" /> {bookInfo.author_name}
                          </span>
                        )}

                        {bookInfo.publisher_name && (
                          <span>
                            <i className="ti ti-building" />{' '}
                            {bookInfo.publisher_name}
                          </span>
                        )}

                        {bookInfo.isbn && (
                          <span>
                            <i className="ti ti-barcode" /> {bookInfo.isbn}
                          </span>
                        )}

                        {bookInfo.category_name && (
                          <span>
                            <i className="ti ti-tag" /> {bookInfo.category_name}
                          </span>
                        )}
                      </div>

                      <div className="ib-book-counts">
                        <div className="ib-count-pill green">
                          <span>{availableCopyCount}</span>
                          Available
                        </div>

                        <div className="ib-count-pill blue">
                          <span>{bookInfo.issued_copies ?? 0}</span>
                          Issued
                        </div>

                        <div className="ib-count-pill amber">
                          <span>{bookInfo.reserved_copies ?? 0}</span>
                          Reserved
                        </div>

                        <div className="ib-count-pill gray">
                          <span>{bookInfo.total_copies ?? 0}</span>
                          Total
                        </div>
                      </div>
                    </div>

                    {selectedCopy && (
                      <div className="ib-copy-detail">
                        <div className="ib-copy-detail-title">
                          <i className="ti ti-check" /> Selected Copy
                        </div>

                        <div className="ib-copy-rows">
                          <div>
                            <span>Accession No</span>
                            <strong>{selectedCopy.accession_no || '-'}</strong>
                          </div>

                          <div>
                            <span>Barcode</span>
                            <strong>{selectedCopy.barcode || '-'}</strong>
                          </div>

                          <div>
                            <span>Copy #</span>
                            <strong>{selectedCopy.copy_number || '-'}</strong>
                          </div>

                          <div>
                            <span>Status</span>
                            <strong>{getCopyStatus(selectedCopy) || '-'}</strong>
                          </div>

                          <div>
                            <span>Condition</span>
                            <strong
                              style={{
                                background: '#dcfce7',
                                color: '#15803d',
                                border: '1px solid #bbf7d0',
                                padding: '2px 10px',
                                borderRadius: '999px',
                                fontSize: '11px',
                                fontWeight: 600,
                                textTransform: 'capitalize'
                              }}
                            >
                              {selectedCopy.condition || 'Good'}
                            </strong>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {form.book_id && !copiesLoading && availableCopyCount === 0 && (
                  <div className="ib-no-copies">
                    <i className="ti ti-alert-circle" /> No available copies for
                    this book.
                  </div>
                )}
              </div>
            </div>

            <div className="ib-card">
              <div className="ib-card-head">
                <i className="ti ti-calendar" /> Issue Date Details
              </div>

              <div className="ib-card-body">
                <div className="ib-grid-3">
                  <div className="ib-field">
                    <label>
                      Issue Date <span>*</span>
                    </label>

                    <input
                      type="date"
                      className="ib-input"
                      value={form.issue_date}
                      onChange={(e) => {
                        const newIssueDate = e.target.value;

                        setForm((prev) => {
                          const prevDays =
                            prev.issue_date && prev.due_date
                              ? Math.ceil(
                                  (new Date(prev.due_date) -
                                    new Date(prev.issue_date)) /
                                    86400000
                                )
                              : 14;

                          const shiftedDue = new Date(newIssueDate);
                          shiftedDue.setDate(
                            shiftedDue.getDate() + Math.max(prevDays, 1)
                          );

                          return {
                            ...prev,
                            issue_date: newIssueDate,
                            due_date: shiftedDue.toISOString().slice(0, 10)
                          };
                        });
                      }}
                      required
                    />
                  </div>

                  <div className="ib-field">
                    <label>
                      Due Date <span>*</span>
                    </label>

                    <input
                      type="date"
                      className="ib-input"
                      value={form.due_date}
                      onChange={(e) =>
                        setForm((prev) => ({
                          ...prev,
                          due_date: e.target.value
                        }))
                      }
                      required
                    />
                  </div>

                  <div className="ib-field">
                    <label>Duration</label>

                    {(() => {
                      if (!form.issue_date || !form.due_date) {
                        return <div className="ib-duration-chip">-</div>;
                      }

                      const days = Math.ceil(
                        (new Date(form.due_date) -
                          new Date(form.issue_date)) /
                          86400000
                      );

                      const invalid = days < 0;

                      return (
                        <div
                          className="ib-duration-chip"
                          style={
                            invalid
                              ? { background: '#fee2e2', color: '#b91c1c' }
                              : undefined
                          }
                        >
                          {invalid
                            ? 'Invalid range'
                            : `${days} day${days !== 1 ? 's' : ''}`}
                        </div>
                      );
                    })()}
                  </div>

                  <div className="ib-field ib-col-3">
                    <label>Remarks</label>

                    <textarea
                      className="ib-textarea"
                      rows={2}
                      value={form.remarks}
                      onChange={(e) =>
                        setForm((prev) => ({
                          ...prev,
                          remarks: e.target.value
                        }))
                      }
                      placeholder="Optional remarks..."
                    />
                  </div>
                </div>
              </div>
            </div>

            {form.member_id && form.book_id && form.book_copy_id && (
              <div className="ib-summary">
                <div className="ib-summary-title">
                  <i className="ti ti-list-check" /> Issue Summary
                </div>

                <div className="ib-summary-grid">
                  <div>
                    <span>Member</span>
                    <strong>
                      {memberInfo ? getFullName(memberInfo) : form.member_id}
                    </strong>
                  </div>

                  <div>
                    <span>Book</span>
                    <strong>
                      {bookInfo?.title || bookInfo?.book_title || form.book_id}
                    </strong>
                  </div>

                  <div>
                    <span>Copy</span>
                    <strong>
                      {selectedCopy?.accession_no || form.book_copy_id}
                    </strong>
                  </div>

                  <div>
                    <span>Issue Date</span>
                    <strong>{form.issue_date}</strong>
                  </div>

                  <div>
                    <span>Due Date</span>
                    <strong>{form.due_date}</strong>
                  </div>

                  <div>
                    <span>Pending Fine</span>
                    <strong
                      className={
                        pendingFineTotal > 0 ? 'text-danger' : 'text-success'
                      }
                    >
                      ₹ {pendingFineTotal.toFixed(2)}
                    </strong>
                  </div>
                </div>
              </div>
            )}

            <div className="ib-actions">
              <button
                type="button"
                className="ib-btn-cancel"
                onClick={() => navigate(`${sectionBase}/issues`)}
              >
                Cancel
              </button>

              <button type="submit" className="ib-btn-submit" disabled={loading}>
                {loading ? (
                  <>
                    <i className="ti ti-loader-2 spin" /> Issuing...
                  </>
                ) : (
                  <>
                    <i className="ti ti-send" /> Issue Book
                  </>
                )}
              </button>
            </div>
          </form>
        </div>

        <CompactIssuedPanel
          issues={issuedBooks}
          search={issueSearch}
          setSearch={setIssueSearch}
          onRefresh={fetchIssuedBooks}
          loading={issueListLoading}
          libraryId={libraryId}
        />
      </div>
    </div>
  );
};

// Named export purely for component-level testing of the info-icon → read-
// only details modal in isolation (see IssuedBookList.test.jsx) — the
// default export/route behavior below is unchanged.
export { CompactIssuedPanel };
export default IssueBook;
